
  import { Component, Prop } from 'vue-property-decorator';
  import Vue from 'vue';
  import RefDashboardGraph from '@/components/dashboard/ReferenceDashboardGraph.vue';
  import { Get } from 'vuex-pathify';
  import MxInfoButton from '@/components/global/MxInfoButton.vue';

  import { IReferenceDashboardResource, IAppInfo } from '@/types/resource.types';
  
  @Component({
      name: 'ReferenceDashboard',
      components: {
        RefDashboardGraph,
        MxInfoButton
      }
  })
  
  
  export default class ReferenceDashboard extends Vue {
    
    //@Get('menuIsCollapsed')
    //menuIsCollapsed: boolean = true;

    /* Props
    ============================================*/
    @Prop({type: Object, required: true})
    readonly referenceDashboard: IReferenceDashboardResource;

    @Get('appInfo')
    readonly appInfo: IAppInfo | null;
      
    /* Data
    ============================================*/
  
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    /* Methods
    ============================================*/
    mounted() {
    }

  }
  
  
  